module.exports = __webpack_public_path__ + "static/L2_visual_5_3_eg-f227fa759337277f5efc25c1e29c2229.png";